import React from "react";
import { withTranslation } from "react-i18next";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
        // You can also log error to an error reporting service here
    }

    render() {
        if (this.state.hasError) {
            const { t } = this.props;
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
                    <h1 className="text-2xl md:text-3xl font-medium-poppins text-red-700 mb-4">
                        {t("errorBoundary.title", "Something went wrong")}
                    </h1>
                    <p className="text-base md:text-lg font-poppins text-gray-700 mb-6">
                        {t(
                            "errorBoundary.description",
                            "An unexpected error occurred. Please try refreshing the page or contact support if the problem persists."
                        )}
                    </p>
                    <details className="w-full max-w-xl bg-red-50 border border-red-200 rounded p-4 text-xs md:text-sm text-red-800 font-mono whitespace-pre-wrap" open>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}

export default withTranslation()(ErrorBoundary);
